/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
//import PerfectScrollbar from 'react-perfect-scrollbar';

class NewContentItem extends Component {
  _goContent = () => {
    const { contentSerial } = this.props.childProps;
    const { setContentSerial } = this.props;

    setContentSerial(contentSerial);
  };
  _onTwitter = () => {
    const { title, comment1 } = this.props.childProps;

    // const url = "https://www.aniplustv.com/items/" + contentSerial;

    window.open(
      "https://twitter.com/intent/tweet?text=" +
        encodeURIComponent(
          '[#애니플러스 21년 1분기 신작 이벤트\n"보고싶은 1분기 신작을 전달하는 신작 공유 서비스"]\n\n-작품명: ' +
            title +
            "\n-방영일정\n[LIVE] " +
            comment1 +
            "\n\n1분기 신작 라인업 보기\nhttp://www.aniplustv.com/event/285\n\n#애니플러스_신작이벤트"
        ),
      "twittersharedialog",
      "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
    );
  };
  _onFacebook = () => {
    const { title, contentSerial } = this.props.childProps;
    const url = "https://www.aniplustv.com/items/" + contentSerial;

    window.open(
      "https://www.facebook.com/sharer/sharer.php?u=" +
        encodeURIComponent(url) +
        "&t=" +
        encodeURIComponent(title ? title : document.title),
      "facebooksharedialog",
      "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
    );
  };
  _onInstar = () => {
    const { contentSerial } = this.props.childProps;
    const url = "https://www.aniplustv.com/items/" + contentSerial;

    window.open(
      "https://plus.google.com/share?url=" + encodeURIComponent(url),
      "googleplussharedialog",
      "menubar=no,toolbar=no,resizable=yes, scrollbars=yes,height=350,width=600"
    );
  };
  _onKakao = () => {
    const { contentSerial } = this.props.childProps;

    const url = "https://www.aniplustv.com/items/" + contentSerial;

    window.open(
      "https://story.kakao.com/s/share?url=" + encodeURIComponent(url),
      "kakaostorysharedialog",
      "menubar=no,toolbar=no,resizable=yes,scrollbars=yes, height=400,width=600"
    );
  };

  render() {
    const { title, img } = this.props.childProps;
    return (
      <Fragment>
        <li>
          <div
            className="thumb"
            onClick={this._goContent}
            style={{ cursor: "pointer" }}
          >
            <img src={img} />
          </div>
          <p
            className="subject"
            onClick={this._goContent}
            style={{ cursor: "pointer" }}
          >
            {title}
          </p>
          <button type="button" onClick={this._onTwitter}>
            <span>신작 공유하기</span>
          </button>
        </li>
      </Fragment>
    );
  }
}
export default shopContext(withRouter(NewContentItem));
